const state = {
    needExportChartId: undefined,
    exportChartData: undefined,
    showingToast: new Set(),
    domResizeObserver: new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.target.__vue__.$parent.resizeChart && mutation.target.__vue__.$parent.resizeChart();
        })
    }),
    computedHistoryQuery: null
};
const getters = {};
const actions = {};
const mutations = {
    selectChart(state, {id, data}) {
        state.needExportChartId = id;
        state.exportChartData = data;
    },
    resetExportChartId(state) {
        state.needExportChartId = undefined;
        state.exportChartData = undefined;
    },
    setComputedHistoryQuery(state, val) {
        state.computedHistoryQuery = val;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}